import { STAFF_SUPPORT_EMAIL } from "../../../utils/userFacingError";

/**
 * Why the dashboard signed the user out by itself (audit 3.1 item 11). The
 * reason travels to the Sign in page as a fixed code in the query string. It
 * never carries personal data.
 */
export type SignOutReason =
  | "sessionEnded"
  | "accountDisabled"
  | "noChamberMemberPro";

export const SIGN_OUT_REASON_QUERY_PARAM = "signedOut";

export const signOutReasonMessages: Record<SignOutReason, string> = {
  sessionEnded:
    "You were signed out because your session ended. Sign in again to continue.",
  accountDisabled:
    "You were signed out because this account cannot access the staff dashboard. Contact your chamber administrator for help.",
  noChamberMemberPro: `You were signed out because your chamber does not have access to Chamber Member Pro. To get access, email ${STAFF_SUPPORT_EMAIL}.`,
};

export const isSignOutReason = (value: unknown): value is SignOutReason =>
  typeof value === "string" &&
  Object.prototype.hasOwnProperty.call(signOutReasonMessages, value);

/** Query string for the Sign in page address, or "" with no reason. */
export const getSignOutReasonQuery = (reason?: SignOutReason): string =>
  reason
    ? `?${SIGN_OUT_REASON_QUERY_PARAM}=${encodeURIComponent(reason)}`
    : "";

/** Message for the Sign in page, or "" when the URL has no known reason. */
export const getSignOutReasonMessage = (search: string): string => {
  const reason = new URLSearchParams(search).get(SIGN_OUT_REASON_QUERY_PARAM);
  return isSignOutReason(reason) ? signOutReasonMessages[reason] : "";
};
